<template>
    <div class="w-100 d-none d-md-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search position-relative tour-search">
        <input type="text" class="form-control v2 border-0 small" v-model="value" @focus="toggleList($event)"
               @blur="toggleList($event)"
               :placeholder="[roleService.ADMIN, roleService.SUPPER_ADMIN].includes(roles[0].name) ? trans('general.component.search.full_search') : trans('general.component.search.placeholder')" aria-label="Search" aria-describedby="basic-addon2">
        <button class="btn btn-light-purple text-dark float-start position-absolute top-0" type="button">
            <i class="fi fi-rr-search"></i>
        </button>
        <div class="suggestions" v-if="showList && value.length > 0" @blur.stop @click.stop>
            <div class="w-100 list-group list-group-flush">
                <a class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                   v-for="item in items" :href="toUrl(item)">
                   <div class="d-flex align-items-center gap-2">
                       <img class="item-image cover center" :src="item.image ? item.image.sizes.sm : '/img/avatar.png'" height="30"
                            width="30" alt="">
                       <p class="mb-0 item-text text-capitalize ms-2 fw-bold">{{ item.name }} {{ item.surname }}</p>
                   </div>
                    <div class="type" v-html="getType(item)"></div>
                </a>
                <no-content-placeholder
                    v-if="items.length === 0"
                    icon="fi-rr-search"
                    title=""
                    :text="trans('general.component.search.no_results')"/>
            </div>
        </div>
        <SearchEngine :value="value" v-on:response="handleResponse($event)"></SearchEngine>
    </div>
</template>

<script>
import SearchEngine from "../molecules/SearchEngine";
import roleService, {roleToScope} from "../../services/RoleService";
import NoContentPlaceholder from "./NoContentPlaceholder.vue";

export default {
    name: "SearchBarDesktop",
    props: ['userId', 'roles'],
    components: {
        SearchEngine,
        NoContentPlaceholder
    },
    data() {
        return {
            value: '',
            items: [],
            showList: false,
            roleService: roleService
        }
    },
    methods: {
        handleResponse(data) {
            this.items = data
        },
        toggleList(event) {
            if (event && event.relatedTarget && event.relatedTarget.classList.contains('list-group-item')) {
                return
            }

            this.showList = !this.showList
        },
        toUrl(item) {
            if (item.id === this.userId) {
                return '/profile'
            }

            return item.roles && item.roles.length > 0 ?  '/user/read/' + item.id : '/children/read/' + item.id
        },
        getType(item) {
            if (item.roles) {
                const rolesMap = {
                    [this.roleService.ADMIN]: 'admin',
                    [this.roleService.TEACHER]: 'teacher',
                    [this.roleService.PARENT]: 'parent',
                    [this.roleService.SUPER_ADMIN]: 'super_admin'
                };

                for (const role of item.roles) {
                    if (rolesMap[role.name]) {
                        return trans(`general.module.role.${rolesMap[role.name]}`);
                    }
                }
            }
            return trans('general.module.role.child');
        }
    }
}
</script>

<style scoped>
.item-image {
    border-radius: 7px;
}
.type {
    font-size: 13px;
}
</style>
